import { OptionsIcon } from "assets/icons/OptionsIcon";
import {
  showErrorToast,
  showSuccessToast,
} from "components/CustomAlerts/CustomToast";
import { ModalConfirm } from "components/ModalConfirm/ModalConfirm";
import { PlanEstudioI } from "interfaces/PlanEstudio";
import React from "react";
import { Dropdown } from "react-bootstrap";
import { deletePlanEstudio } from "services/planesEstudio";

interface Props {
  elemento: PlanEstudioI;
  onClickEdit: (elemento: PlanEstudioI) => void;
  onClickShowDetail: (elemento: PlanEstudioI) => void;
  refreshTable: () => void;
}

export const PlanesRowActions = ({
  elemento,
  onClickEdit,
  onClickShowDetail,
  refreshTable,
}: Props) => {
  const handleDelete = async (id: string | number) => {
    try {
      await deletePlanEstudio(id);
      showSuccessToast("¡El plan de estudio fue eliminado con éxito!");
      refreshTable();
    } catch (error:any) {
      showErrorToast("Error eliminando el plan de estudio: ", error.message);
    }
  };

  return (
    <Dropdown className="acciones-dropdown | d-flex justify-content-center">
      <Dropdown.Toggle>
        <OptionsIcon />
      </Dropdown.Toggle>

      <Dropdown.Menu>
        <Dropdown.Item onClick={() => onClickShowDetail(elemento)}>
          Ver detalle
        </Dropdown.Item>

        <Dropdown.Item onClick={() => onClickEdit(elemento)}>
          Editar
        </Dropdown.Item>

        <ModalConfirm
          title="Eliminar plan de estudio"
          onConfirm={() => handleDelete(elemento.id)}
          message={
            <p>
              Estas por eliminar el plan de estudio {elemento.nombre} <br />
              <b>¿Querés realizar esta acción? Esta acción es irreversible.</b>
            </p>
          }
          renderButton={(handleShow: () => void) => (
            <Dropdown.Item onClick={handleShow}>Eliminar</Dropdown.Item>
          )}
        />
      </Dropdown.Menu>
    </Dropdown>
  );
};
